module.exports = __webpack_public_path__ + "static/1ob-seal-hoodie-dee13969de343616c8146eab47102611.webp";